var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDhoti01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:#fff;stroke:#000;stroke-miterlimit:10;}.cls-1{stroke-width:2px;}.cls-2{stroke-width:1.98px;}.cls-3{stroke-width:0.99px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.24,150c8.55-7.57,18.28,0,45.33,1.78,19.73,1.33,62,.51,79.51-1.07,2.6-.24,9.48-.92,13.68,3.21,2,2,2.24,3.94,3.59,8.56,3.46,11.78,5.51,11,7.56,20,1.52,6.66,2.56,11.2.72,16.41-1.49,4.22-3.43,4.84-4.32,9.28s.81,5.36,1.08,12.13c.18,4.58-.56,5.15-1.44,14.63-.41,4.4-.56,7.6-.72,11.07-.67,14.51.75,14.41,0,22.12-.78,8-1.64,16.8-7.19,25.34-2.4,3.68-4.84,6-5,10.34-.26,5.42,3.35,6.13,4,11.42,1,9-8.88,12.71-7.56,22.13.6,4.26,2.77,4.5,2.52,8.56-.3,4.88-3.56,6.31-4,12.13-.22,3.26.81,2.71.72,6.78A42.45,42.45,0,0,1,269.16,377c-1.09,3.37-1.53,3.8-1.44,5.35.19,3,2,3.77,2.52,7.14a12.42,12.42,0,0,1-.72,6.06c-1.31,4-3.6,5.39-5,7.5-5,7.34,3.19,18.91.72,20.69-2.32,1.66-11.71-6.85-15.48-11.06C217.45,376.55,213.86,226.1,212.32,226c-.6,0-5.29,22.65-10.08,92.07-1.76,25.61-2.82,47-15.47,71.72-9.9,19.32-22.9,32.83-25.54,31.4-1.73-.92,2-7.59-1.08-16.77-1.85-5.43-3.92-5.3-4.68-9.63-1.37-7.89,5.1-10.55,3.6-17.13-1.4-6.13-7.68-6.71-7.92-12.85-.14-3.63,2-4.1,1.8-7.85-.36-5.73-5.58-6.78-5.76-11.42-.19-5.28,6.51-6.39,6.84-11.77.36-5.76-7.16-6.65-9.35-14.28s4.15-11.09,3.23-20.69c-.72-7.55-4.83-7.32-7.91-16.06-4.54-12.88,3.11-17,.36-35.33-1.58-10.51-4.34-10.7-4.32-19.62,0-7.46,2-11.9-.72-18.2-2-4.65-4-4.56-5.75-8.57-2.7-6.21-.35-12.34,2.87-21.41C142.1,152.48,140.67,152.29,143.24,150Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.43,157.49c-.57,4.23-4.1,7.42-5,11.5-1.08,4.08-1.19,8.49-3,12.46-3.55,7.87-11.22,13.1-12,22a14.45,14.45,0,0,1,.77-6.37c2-6,6.93-10.87,9.42-16.47,2.13-4.52,2-10.48,4.7-15.12,1.62-2.77,4.06-4.94,5.09-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.5,161.86c-8.64,7.72-7.75,20.08-11.51,30.24-1.28,3.51-3,6.8-4.45,10.11a98.39,98.39,0,0,0-8.87,42.37,81.08,81.08,0,0,1,7.05-43.2c1.56-3.34,3.21-6.59,4.51-9.95,3.84-9.9,3.8-22.83,13.27-29.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.5,162.08c-4.27,7.31-10.16,14.94-14,22.49-5.12,10.64-5.86,22.71-9.69,33.85a50.69,50.69,0,0,1-3.62,8.14c4.46-11.11,4.86-23,8.29-34.45,3.31-11.63,11.72-20.7,19-30Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.13,164.13c-9.58,9.25-14.4,22-18.92,34.24a385.69,385.69,0,0,0-17,63.68c.39-4.4,1-8.77,1.61-13.15A250.78,250.78,0,0,1,169,210.22c5.82-16.38,11.25-34.59,25.11-46.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.16,236.88a94.58,94.58,0,0,0-7.49,26.63c-1.28,9.21-1.38,18.53-2.13,27.81-1.71-18.45-1-38.56,9.62-54.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.88,164.14c-2.59,10.68-6.73,26.27-9.59,37.06-3.49,12.35-6.27,24.74-10.61,36.87-2.42,6-5.72,11.57-8.93,17.07-6.4,11-13,22-20.05,32.63-3.58,5.29-7.24,10.53-11.15,15.57,3.54-5.3,7-10.64,10.33-16.09,5.84-9.33,13.71-23.34,19.3-33a130.66,130.66,0,0,0,8.64-16.9c4.42-11.83,7.21-24.44,11-36.54,3.16-10.73,7.72-26.11,11.07-36.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.49,170.7c-1.37,17.58-9.11,33.78-13.68,50.61-2.8,10.14-4.57,20.5-7.78,30.57-1.72,5-5.32,14.89-7.18,19.8-3.51,9.5-7.46,20-11.11,29.49-2.49,6.54-5,13.27-9.29,18.9a25.62,25.62,0,0,1-7.83,7,26.78,26.78,0,0,0,7.41-7.29c5.66-8.37,8.45-19.5,12-28.92,6.79-19.65,15.14-39.36,19.46-59.78,4.29-20.63,15-39.42,18-60.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.47,190.36c-.19,23-4.33,45.76-9.3,68.13C195.23,288,190.24,320,169.84,343.66a68.46,68.46,0,0,1-17.62,14.65A71,71,0,0,0,169.09,343c14.61-17.83,20.9-40.56,26-62.63,7.05-29.7,14.5-59.47,16.34-90Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.91,282.77c-.82,15.52-8.91,29.41-11.61,44.54-3.86,19.7-5,42.93-21.84,56.56a98.17,98.17,0,0,1-12.84,8.56,115.76,115.76,0,0,0,12.2-9.3c15.87-14.17,16.5-36.74,20.63-56.21,3-15.2,11.44-28.74,13.46-44.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.51,340c-2.1,6.9-5.61,13.21-8.79,19.64s-7.65,12.68-14,16.3C165,371,168.78,365.15,172,358.71s7-12.49,10.56-18.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.8,331.87c-3.27,14.65-7.1,29.14-11.09,43.61-2.08,7.25-4.41,14.65-8.89,20.86a27.93,27.93,0,0,1-8.36,7.77c-3.27,1.9-6.77,3.34-9.35,6.13a16.64,16.64,0,0,1,4.13-3.85c3.09-2.09,6.33-3.92,8.88-6.65a40.71,40.71,0,0,0,8.3-14.17c5.87-17.75,10.19-36,16.38-53.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.17,175.72c-1,16.84,1.78,33.47,3.18,50.21.75,8.38,1,16.84,1,25.24a81.6,81.6,0,0,0,.84,12.42c2.16,12.33,5.34,24.59,8.47,36.7,4.53,15.94,9.67,32.48,21.92,44.3,5.78,6.05,12.42,11.23,19,16.49a175,175,0,0,1-19.66-15.8c-12.66-11.65-18.39-28.4-23-44.5-2.29-8.12-4.22-16.3-6.18-24.47s-3.4-16.69-3.2-25.14-.14-16.74-.66-25.12c-1-16.71-3.54-33.58-1.65-50.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.37,324.92a155.91,155.91,0,0,0,6.38,18.85c2.21,5.4,5,13.18,7.69,18.28,2.49,5.14,7.6,11.76,10.89,16.51q5.78,8.15,11.22,16.52-6.39-7.68-12.48-15.59c-4-5.28-8.32-10.45-11.41-16.53s-5.14-12.38-7.37-18.66a98.38,98.38,0,0,1-4.92-19.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.41,367.35c1.23,4.66,3.49,8.85,5.65,13.13l6.42,12.84a229.85,229.85,0,0,0,14.17,24.89c-6.61-7-11.61-15.42-15.95-24-2.15-4.3-4.15-8.67-6-13.07s-3.83-9-4.24-13.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.21,369.61a62.17,62.17,0,0,1,7.68,13.92l-.26-.32a19.5,19.5,0,0,1,4.32,5c-1.61-1.11-3.82-2.67-5.46-3.67a62.51,62.51,0,0,1-6.28-14.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.83,172.14c.59,27,12.25,64.65,18.21,91.18,1.6,6.64,3.68,16.13,5.47,22.62,4,15.06,12.51,28.21,21.51,40.73,4.49,6.34,8.83,12.8,14.23,18.41-5.73-5.3-10.27-11.7-15-17.83-19.11-25.13-21.14-33.52-28.13-63.47-3.09-13.35-7.68-32.19-10.58-45.4-3.31-15.18-6.07-30.66-5.69-46.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.94,291.68c.42,7.09,5.23,12.66,10.34,17.08,3.88,3.57,8.79,5.2,13.58,7.24a16.17,16.17,0,0,1,4.43,2.95c-4.61-2.72-10.17-2.87-14.84-5.57-7.34-4.36-14.87-12.56-13.51-21.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.93,168.62a73,73,0,0,1,11.44,25.27c1.1,4.54,1.76,9.12,2.93,13.53s2.56,8.82,4,13.22c2.81,8.8,5.59,17.62,8.27,26.47s5.11,17.94,11.59,24.74c-7.07-6.21-10.15-15.62-13.08-24.26s-5.84-17.55-8.68-26.34c-1.4-4.41-2.83-8.83-3.92-13.37s-1.71-9.16-2.62-13.65a84.47,84.47,0,0,0-9.92-25.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.86,163.44c1.54.45,2.22,2.11,2.82,3.44l1.83,4.18,3.67,8.36c5.17,12.31,13,29.69,17.62,42.15a35.51,35.51,0,0,1,1.65,9.19c.85,24.32,10.57,47.56,10.86,72-.91-12.16-3.93-24-6.77-35.76A224.28,224.28,0,0,1,262.22,240c-.85-6-.35-12.13-2.28-17.86-.91-2.82-2.13-5.61-3.25-8.44-3.4-8.43-10.13-25.47-13.41-33.94L240,171.26,238.4,167c-.52-1.38-1-3-2.54-3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.69,162.59c2.09-1.37,3.75,2.24,4.62,3.65a21.34,21.34,0,0,1,2.4,5.93c1,4.25-.27,8.22,1,12.37-2.72-3.29-2.07-8.13-3-11.94a48.32,48.32,0,0,0-2.42-7.13c-.48-1.18-1-3.28-2.65-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.16,187.51a170.77,170.77,0,0,1,12.67,29.56c2.91,10.49,2.22,21.48.86,32.12-.26-10.58.13-21.36-2.79-31.59-3-10-7.27-20.2-10.74-30.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.63,161.69A66.53,66.53,0,0,1,280.24,187c.94,4.55,1.13,9.19,1.67,13.68s1.68,8.84,2.5,13.44a68.24,68.24,0,0,1,.53,13.89c-.5,13.73-1.12,27.45-2.1,41.16-.22-13.74-.06-27.47.2-41.21a67.44,67.44,0,0,0-.6-13.51c-.74-4.41-2-8.92-2.41-13.57s-.58-9.15-1.32-13.61a75.74,75.74,0,0,0-9.08-25.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.33,98.83c-10,12-9.74,27.39-9.33,42.17.1,3.55-.35,4.28.59,10.76a281.76,281.76,0,0,0,75.67,8.5,281.18,281.18,0,0,0,61.5-8.34,145.14,145.14,0,0,0-2.43-25.75c-2.94-16.55-4.41-24.83-9.5-29.5-9.34-8.6-19.56.67-47.83,0-32.24-.77-51.13-13.6-65.33-1.34A27.31,27.31,0,0,0,152.33,98.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,104.21c-2.07-.19-2.83,3.58-3.43,5.12-.72,2.14-1.41,4.27-2,6.41a49.72,49.72,0,0,0-1.23,13.16A267.09,267.09,0,0,1,167.1,156a267.11,267.11,0,0,1-1.18-27.13c0-4.56.28-9.33,1.84-13.68a53.69,53.69,0,0,1,2.67-6.32c.87-1.57,2.25-5.3,4.52-4.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.18,121.89c.57,8.78.18,18.69-5.6,25.82,3.25-8.39,3.38-17.14,5.6-25.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.69,110.42a19,19,0,0,0-3.3,17.26,64.32,64.32,0,0,1,1.78,9.34,31.06,31.06,0,0,1-.59,9.53c-.12-6.41-1.46-12.26-3.14-18.43s-.14-13.78,5.25-17.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.88,103.83a19.39,19.39,0,0,0-3.52,7c-.79,2.59-.29,5.39-1.18,7.94-3.62,10,.64,21.13,7.52,28.8a77.15,77.15,0,0,0,5.68,5.61,27.57,27.57,0,0,1,4.21,4.36,3,3,0,0,1,.56,1.92,2.81,2.81,0,0,0-.73-1.8,31.38,31.38,0,0,0-4.51-3.93,61.31,61.31,0,0,1-6.1-5.32c-5.79-5.77-9.76-13.73-10-22-.13-3.44,1.18-6.75,2-10,.11-.57.15-1.34.2-1.91a15.42,15.42,0,0,1,5.84-10.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.15,107.79c.94,4.15,1.88,8.25,2.95,12.3,1.48,6.19,4.08,12,5.24,18.31,1,6.39.22,12.91-1.09,19.15-.21-8.39.1-16.73-2.83-24.69a76.25,76.25,0,0,1-4.27-25.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.47,104.15c-5,12.77,5,24.31,6.88,36.62.71,4.43,0,8.8-.89,13-.17-4.3-.11-8.58-1.14-12.57-3-11.73-12.87-25.18-4.85-37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.78,114.45c-1.89,4.32-5.64,8.1-6.52,12.7a48.39,48.39,0,0,0-.41,7.14,70.89,70.89,0,0,1-.56,7.38c-.81-5-1.67-9.76-1-14.89,1-5.07,5.12-8.68,8.49-12.33Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.72,97.56c5.16,5.17,16.91,4.78,16.91,4.78,12.9-.43-.32,2,31.21,2.24,15.69.13,23.54.2,34.57-.78a259.17,259.17,0,0,0,33.8-5.26c.33-1.86-.06-2.7-.48-3.12s-.93-.49-1.05-1,.63-.91.67-1.75-.9-1.14-1-2.25c0-.61.24-.64.48-1.75.2-1,.39-1.85,0-2.25s-1.48.42-3.46.39c-1.66,0-1.78-.69-3-.48-1.64.28-1.9,1.64-3.16,1.56-1.06-.07-1.13-1-2.31-1.17s-1.28.59-2.88,1-1.6-.19-3.27.1c-1.84.32-1.9,1-3.36,1.07s-1.57-.63-3.07-.58-1.53.64-3.07.87-1.93-.35-3.84-.39c-2.14,0-2,.71-4.23.78s-2.65-.72-5-.48c-1.34.13-1.34.41-2.69.48-1.85.11-2.05-.39-3.84-.39-2,0-2.12.63-4.13.59-1.62,0-1.55-.43-3.17-.49-2.13-.08-2.49.6-4.61.59-1.76,0-1.6-.48-3.56-.59-2.3-.13-2.55.52-5.09.49-1.82,0-1.79-.36-3.84-.39-2.26,0-2.26.38-4,.29-2.48-.11-2.75-.93-5-.88-1.78,0-1.66.56-3.37.59-2.39,0-2.69-1-5.09-1-2,0-2.07.73-3.74.49-2.07-.29-2.27-1.45-3.94-1.36-1.52.08-2,1.1-3.36.78-.85-.21-.75-.65-1.73-1-1.49-.5-2,.42-3.55,0-1.17-.32-1.2-1-2.31-1.07s-1.08.4-2,.39c-1.63,0-2-1.49-3.27-1.37a3.09,3.09,0,0,0-2.21,2.34c-.27,1.15.39,1.5.29,3.42a7.3,7.3,0,0,1-.38,2.14c-.44,1.27-.95,1.55-1,2.34A3,3,0,0,0,153.72,97.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154.88,90.54a18.05,18.05,0,0,1,4.61.68c1.68.49,2.29,1,3.84,1.08,1.74.13,1.77-.4,3.36-.3,2.18.14,2.62,1.17,5.09,1.56,1.61.26,1.52-.17,3.17,0,3.78.4,4.66,2.69,7.1,2.25,1.57-.29,1.42-1.27,3.27-1.76s2.66.31,5.57.88a50.06,50.06,0,0,0,8,.29c2.65,0,4,0,5-.1,3.84-.38,4.8-1.2,7-.58a17.52,17.52,0,0,0,3.08.88,12.61,12.61,0,0,0,3.07,0c3.71-.39,3.85-1,6-1.08,2.94-.11,3.18,1.06,6,.78,2.19-.21,2-.88,4.13-1.07,2.89-.25,3.42.93,6.34.59,1.7-.21,1.84-.65,3.56-.69,2,0,2.2.54,3.84.49,2.26-.07,2.34-1.22,5-1.66,2.19-.36,2.39.39,4.61-.09,1.85-.41,1.89-1,3.55-1.17,1.83-.24,2.32.36,4,.19a7.92,7.92,0,0,0,3.65-1.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "158.91 93.1 158.91 94.96 157.85 95.86 157.85 97.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "162.33 93.73 162.33 95.59 161.28 96.49 161.28 97.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "167.1 94.96 167.1 96.82 166.04 97.72 166.04 99.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "171.62 95.23 171.62 97.09 170.57 97.99 170.57 99.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "176.58 95.86 176.58 97.72 175.52 98.62 175.52 100.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "180.52 97.09 180.52 98.95 179.46 99.85 179.46 101.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "184.94 97.37 184.94 99.22 183.88 100.13 183.88 101.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "241.69 97.09 241.69 98.95 242.75 99.85 242.75 101.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "247.45 96.64 247.45 98.5 248.51 99.4 248.51 100.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "252.7 95.86 252.7 97.72 253.76 98.62 253.76 100.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "257.75 94.96 257.75 96.82 258.8 97.72 258.8 99.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "261.5 94.28 261.5 96.13 262.56 97.03 262.56 98.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "265.1 93.4 265.1 95.25 266.16 96.16 266.16 97.66"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 189.26,
    y1: 97.37,
    x2: 188.1,
    y2: 101.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 193.46,
    y1: 97.83,
    x2: 192.31,
    y2: 102.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 197.88,
    y1: 97.83,
    x2: 196.73,
    y2: 102.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 201.9,
    y1: 97.83,
    x2: 200.75,
    y2: 102.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 205.18,
    y1: 98.15,
    x2: 204.99,
    y2: 102.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 210.02,
    y1: 98.15,
    x2: 209.83,
    y2: 102.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 214.63,
    y1: 98.15,
    x2: 214.44,
    y2: 102.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 218.87,
    y1: 98.19,
    x2: 219.71,
    y2: 102.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 223.74,
    y1: 98.19,
    x2: 224.58,
    y2: 102.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 228.44,
    y1: 97.8,
    x2: 229.27,
    y2: 102.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 232.72,
    y1: 97.17,
    x2: 233.55,
    y2: 101.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 236.87,
    y1: 97.33,
    x2: 237.71,
    y2: 101.98
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhoti01);
export default __webpack_public_path__ + "static/media/DHOTI-01.0f5e0ff629c66a1fd720d183c8ea33b8.svg";
export { ForwardRef as ReactComponent };